import { useQuery } from '@apollo/client/react';

import { GetOrganizationElectronicPrescriptionDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';

export const useOrganizationElectronicPrescription = () => {
  const { data, loading, error } = useQuery(GetOrganizationElectronicPrescriptionDocument);
  const me = data ? getMe(data) : null;
  const electronicPrescription = !!me?.organization.webBookingsSetting?.electronicPrescription;

  return {
    loading,
    error,
    electronicPrescription,
  };
};
